var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height q-pa-md"},[_c('jt-profile-permission',{attrs:{"id":_vm.id,"interface":_vm.nmInterface,"name":_vm.name,"params":_vm.params}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }